//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Malinas',
  data() {
    return {
      defaultJson:{
        "DurationLabour2": "超过 6 小时",
        "Breaking0 (short)": "否",
        "Interval2 (short)": "< 3 min",
        "Interval0": "超过 5 分钟",
        "DurationContractions0 (short)": "< 1 min",
        "Interval2": "不到 3 分钟（5 分钟内至少 2 次）",
        "DurationContractions0": "不到 1 分钟",
        "DurationLabour": "阵痛持续时间",
        "Breaking": "破膜",
        "DurationContractions1": "1 分钟",
        "Interval": "宫缩间隔",
        "NumberPreg": "怀孕次数",
        "Breaking0": "否",
        "Breaking2": "> 1 小时",
        "DurationContractions2": "超过 1 分钟",
        "Childbirth imminent": "即将分娩",
        "Interval0 (short)": "> 5 min",
        "Breaking1 (short)": "< 1 h",
        "DurationContractions": "宫缩持续时间",
        "DurationLabour0": "不到 3 小时",
        "DurationLabour2 (short)": "> 6 h",
        "Breaking2 (short)": "> 1 h",
        "DurationContractions1 (short)": "1 min",
        "Interval1": "介于 3 - 5 分钟",
        "DurationContractions2 (short)": "> 1 min",
        "DurationLabour1 (short)": "3 - 5 h",
        "DurationLabour1": "介于 3 - 5 小时",
        "DurationLabour0 (short)": "< 3 h",
        "Breaking1": "最近（< 1 小时）",
        "Interval1 (short)": "3 - 5 min"
      },
      form:{
        numberofpregnancies:'',
        durationoflabour:'',
        durationofcontractions:'',
        intervalofcontractions:'',
        breakingofwaters:'',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'1'},
        {value:"1",name:'2'},
        {value:"2",name:'>= 3'},
      ],
      dataList2:[
        {value:"0",name:'不到 3 小时', shortName:'< 3 h'},
        {value:"1",name:'介于 3 - 5 小时', shortName:'3 - 5 h'},
        {value:"2",name:'超过 6 小时', shortName:'> 6 h'},
      ],
      dataList3:[
        {value:"0",name:'不到 1 分钟', shortName:'< 1 min'},
        {value:"1",name:'1 分钟', shortName:'1 min'},
        {value:"2",name:'超过 1 分钟', shortName:'> 1 min'},
      ],
      dataList4:[
        {value:"0",name:'超过 5 分钟', shortName:'> 5 min'},
        {value:"1",name:'介于 3 - 5 分钟', shortName:'3 - 5 min'},
        {value:"2",name:'不到 3 分钟（5 分钟内至少 2 次）', shortName:'< 3 min'},
      ],
      dataList5:[
        {value:"0",name:'否', shortName:'否'},
        {value:"1",name:'最近（< 1 小时）', shortName:'< 1 h'},
        {value:"2",name:'> 1 小时', shortName:'> 1 h'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        	// numberofpregnancies + durationoflabour + durationofcontractions + intervalofcontractions + breakingofwaters
        let result = form.numberofpregnancies + form.durationoflabour + form.durationofcontractions + form.intervalofcontractions + form.breakingofwaters
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/Malinas.vue